import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contextStore/AuthContext";
import { AllPostProvider } from "./contextStore/AllPostContext";
import { PostProvider } from "./contextStore/PostContext";
import { LocationProvider } from "./contextStore/LocationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LocationProvider>
      <AuthProvider>
        <AllPostProvider>
          <PostProvider>
            <App />  {/* ✅ Main router lives here */}
          </PostProvider>
        </AllPostProvider>
      </AuthProvider>
    </LocationProvider>
  </React.StrictMode>
);
